import { useState } from "react";
import { Form, Input, Label, Row } from "reactstrap";
import { SendMessage } from "../../../../constants";
import RenderInput from "../../../commonComponents/RenderInput";
import UsePathName from "../../../../utils/UsePathName";

const ContactForm = () => {
  const Path = UsePathName();
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    message: "",
    agree: false,
  });

  const handleChange = (key: string, value: string | boolean) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (
      !form.firstName ||
      !form.lastName ||
      !form.phone ||
      !form.email ||
      !form.message ||
      (Path[2] === "contact-3" && !form.agree)
    ) {
      alert("Please fill in all fields.");
      return;
    }
    const msg = `Hello, my name is ${form.firstName} ${form.lastName}. Phone: ${form.phone}, Email: ${form.email}. Message: ${form.message}`;
    const url = `https://wa.me/601162914913?text=${encodeURIComponent(msg)}`;
    window.open(url, "_blank", "noopener,noreferrer");
    // Optionally reset form here
    // setForm({ firstName: "", lastName: "", phone: "", email: "", message: "", agree: false });
  };

  return (
    <Form className="login-form contact-form" onSubmit={handleSubmit}>
      <Row>
        <RenderInput
          placeholder="First Name"
          ColClass="col-lg-6"
          mainClass="form-input"
          review
          value={form.firstName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange("firstName", e.target.value)}
        />
        <RenderInput
          placeholder="Last Name"
          ColClass="col-lg-6"
          mainClass="form-input"
          review
          value={form.lastName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange("lastName", e.target.value)}
        />
        <RenderInput
          placeholder="Phone Number"
          ColClass="col-lg-6"
          mainClass="form-input"
          inputType="number"
          review
          value={form.phone}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange("phone", e.target.value)}
        />
        <RenderInput
          placeholder="Email"
          ColClass="col-lg-6"
          mainClass="form-input"
          inputType="email"
          review
          value={form.email}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange("email", e.target.value)}
        />
        <RenderInput
          placeholder="Message"
          ColClass="col-xs-12"
          mainClass="form-input"
          inputType="textarea"
          inputClass="mb-0"
          review
          value={form.message}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange("message", e.target.value)}
        />
        {Path[2] === "contact-3" && (
          <div className="form-check-box">
            <Input
              type="checkbox"
              id="message"
              required
              checked={form.agree}
              onChange={(e) => handleChange("agree", e.target.checked)}
            />
            <Label htmlFor="message">I agree to receive other communication message.</Label>
          </div>
        )}
        <button type="submit" className="btn-solid col-xl-4 col-lg-5 col-xs-8">
          {SendMessage}
        </button>
      </Row>
    </Form>
  );
};

export default ContactForm;